"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipLinkList = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _ListItem = require("./ListItem");

var _styles = require("../shared/styles");

var _excluded = ["links", "LinkWrapper"];
var List = /*#__PURE__*/(0, _theming.styled)("ul", process.env.NODE_ENV === "production" ? {
  target: "e2mj3990"
} : {
  target: "e2mj3990",
  label: "List"
})("min-width:180px;border-radius:", _styles.spacing.borderRadius.small, "px;overflow:hidden;margin:0;padding:0;list-style:none;");

var TooltipLinkList = function TooltipLinkList(_ref) {
  var links = _ref.links,
      LinkWrapper = _ref.LinkWrapper,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(List, rest, links.map(function (data, index) {
    return /*#__PURE__*/_react["default"].createElement(_ListItem.ListItem // eslint-disable-next-line react/no-array-index-key
    , (0, _extends2["default"])({
      key: index,
      LinkWrapper: LinkWrapper
    }, data));
  }));
};

exports.TooltipLinkList = TooltipLinkList;